import { render, staticRenderFns } from "./RequestFormsBuilder.vue?vue&type=template&id=b2fb0c6c&scoped=true"
import script from "./RequestFormsBuilder.vue?vue&type=script&lang=js"
export * from "./RequestFormsBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2fb0c6c",
  null
  
)

export default component.exports